import { render } from "./BxsTextareaField.vue?vue&type=template&id=26aecf21&scoped=true"
import script from "./BxsTextareaField.vue?vue&type=script&lang=js"
export * from "./BxsTextareaField.vue?vue&type=script&lang=js"

import "./BxsTextareaField.vue?vue&type=style&index=0&id=26aecf21&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/vueApps/ronchipiero.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26aecf21"]])

export default __exports__